"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTHER = exports.EXPERT = exports.BROWSER = exports.RECURRENCE = exports.SOURCE_PAGES = exports.VISITORS_ENVIRONMENT = exports.DEVICES = exports.EXTERNAL_DATA = exports.USER_SATISFACTION = exports.GEOLOCATION = exports.PURCHASE = exports.NAVIGATION = exports.TECHNOLOGY = exports.USER_PREFERENCES = exports.BEHAVIOR = void 0;
exports.BEHAVIOR = 100;
exports.USER_PREFERENCES = 101;
exports.TECHNOLOGY = 102;
exports.NAVIGATION = 103;
exports.PURCHASE = 104;
exports.GEOLOCATION = 105;
exports.USER_SATISFACTION = 106;
exports.EXTERNAL_DATA = 107;
exports.DEVICES = 200;
exports.VISITORS_ENVIRONMENT = 201;
exports.SOURCE_PAGES = 202;
exports.RECURRENCE = 203;
exports.BROWSER = 204;
exports.EXPERT = 205;
exports.OTHER = 206;
//# sourceMappingURL=categoriesTypes.js.map